import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Row, Col, Form, Button, Schema } from "rsuite";
import { Patterns } from "../scripts/helper";
import {DevicesSelector} from '../redux/selector'
import {SetSelectedDevice, SetDevices} from '../redux/actions'
import { findAllByTestId } from "@testing-library/dom";

class AddDeviceComponent extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.nullForm = {
      name: "",
      mobile: "",
    };
    this.state = {
      formValue: this.nullForm,
    };
  }

  handleAddNumber = () => {
    const { formValue } = this.state;
    const { setDevices, devices, setSelectedDevice, inForce , setShowForm} = this.props;
    const wellcome = new Audio("/assets/welcome.mp3");
    if (this.formRef.current.check()) {
      let newDevices = [];
      if (!!devices) {
        newDevices = [...devices, formValue];
      } else {
        newDevices = [formValue];
      }
      setSelectedDevice(formValue.mobile);
      setDevices(newDevices);
      this.setState({ formValue: this.nullForm });
      if(!inForce){
        setShowForm(false);
      } else {
        wellcome.play();
      }
    } else {
      console.error("Form Error");
    }
  };

  render() {
    const { formValue } = this.state;
    const {inForce, setShowForm} = this.props;
    const { StringType, NumberType } = Schema.Types;
    const model = Schema.Model({
      name: StringType()
        .isRequired("اجباری")
        .rangeLength(1, 10, "کمتر از ۱۰ کاراکتر"),
      mobile: NumberType().isRequired("اجباری").pattern(Patterns.mobile),
    });

    return (
      <Form
        autoComplete="off"
        formValue={formValue}
        onChange={(formValue) => this.setState({ formValue })}
        fluid
        model={model}
        ref={this.formRef}
      >
        <Form.Group>
          <Form.ControlLabel>نام دستگاه</Form.ControlLabel>
          <Form.Control name="name" placeholder="نام نمایشی" />
        </Form.Group>
        <Form.Group>
          <Form.ControlLabel>شماره همراه</Form.ControlLabel>
          <Form.Control
            type="number"
            name="mobile"
            placeholder="09..."
            style={{ direction: "ltr" }}
          />
        </Form.Group>
        <Row>
          <Col xs={inForce ? 24 : 12}>
            <Button
              block
              type="submit"
              appearance="primary"
              color="orange"
              onClick={() => this.handleAddNumber()}
            >
              ثبت
            </Button>
          </Col>
          {
              !inForce &&
          <Col xs={12}>
            <Button
              block
              type="button"
              onClick={() => setShowForm(false)}
            >
              لغو
            </Button>
          </Col>
          }
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  devices: DevicesSelector,
});
const mapDiapatchToProps = (dispatch) => ({
  setDevices: (data) => dispatch(SetDevices(data)),
  setSelectedDevice: (device) => dispatch(SetSelectedDevice(device)),
});

export default connect(mapStateToProps, mapDiapatchToProps)(AddDeviceComponent);
